import Cookies from 'universal-cookie';

const SESSION_COOKIE = '101Obex';

/** Token de sesion del TPV, el web_token que deja login-pin en la cookie. Cadena vacia si no hay o si ya caduco. */
export const getAccessToken = (): string => {
  try {
    const cookie = new Cookies().get(SESSION_COOKIE);
    if (!cookie || !cookie.token) return '';
    if (cookie.expiresAt && Date.now() >= Number(cookie.expiresAt)) return '';
    return cookie.token;
  } catch {
    return '';
  }
};

/** Query string a partir de un objeto; omite undefined, null y cadenas vacias. */
export const buildQuery = (params: Record<string, any>): string => {
  const parts: string[] = [];
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === '') return;
    parts.push(`${key}=${encodeURIComponent(String(value))}`);
  });
  return parts.length > 0 ? `?${parts.join('&')}` : '';
};

/** El gateway envuelve la respuesta en .data y/o .result. */
const unwrapEnvelope = (res: any): any => {
  let out = res;
  if (out && out.data) out = out.data;
  if (out && out.result) out = out.result;
  return out;
};

/**
 * El cuerpo util. Segun el endpoint llega en .response (login-pin, books_list)
 * o en .result (terminal-token, logout): el gateway no es uniforme.
 */
const unwrapBody = (res: any): any => {
  const out = unwrapEnvelope(res);
  if (out && typeof out === 'object') {
    if (out.response !== undefined) return out.response;
    if (out.result !== undefined) return out.result;
  }
  return out;
};

/**
 * Los .avap devuelven sus errores con HTTP 200 y un STRING como cuerpo:
 *   {"success":true,"data":{"result":{"response":"PIN incorrecto"}}}
 * Una ruta no publicada llega distinto, con success false:
 *   {"success":false,"message":"Service not Available."}
 *
 * Devuelve el mensaje de error, o null si la respuesta trae datos validos.
 */
export const getErrorMessage = (res: any): string | null => {
  if (!res) return 'Sin respuesta del servidor.';
  if (res.success === false) return res.message || 'Servicio no disponible.';
  const body = unwrapBody(res);
  if (typeof body === 'string') return body;
  if (body === null || body === undefined) return 'Respuesta vacia del servidor.';
  return null;
};

/** Array de una respuesta de listado, plana o paginada. */
export const unwrapList = (res: any): any[] => {
  const body = unwrapBody(res);
  if (Array.isArray(body)) return body;
  if (body && Array.isArray(body.data)) return body.data;
  return [];
};

/** Objeto de una respuesta que no es un listado. */
export const unwrapObject = (res: any): any => unwrapBody(res);

/** Base64 de un texto UTF-8 (btoa solo acepta latin1). */
export const toBase64 = (text: string): string => btoa(unescape(encodeURIComponent(text)));
